var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M52.498 19.507A23.9 23.9 0 0 0 40 16c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24c0-1.998-.244-3.939-.704-5.794l-19.764 14.31-10.339-14.734zM40.585 50.584 30.245 35.85l-3.342 13.34z",
    clipRule: "evenodd"
  })));
};
export default SvgEdit;